import PropTypes from 'prop-types';
import { injectCustomerColorsCSS } from 'lib/utility/helpers';
import ChakraComponentWrapper from '../../../../lib/components/ChakraComponentWrapper';

const DEFAULT_PROGRAM = {
  playlists: [
    {
      name: 'Life Transactions',
      description: 'The basics...what you need to know about your finances',
      image: 'http://s3.amazonaws.com/everfi-next/uploads/demo-images/Savings.png',
    },
    {
      name: 'Financing Education',
      description: 'The tools you need to prepare for education expenses.',
      image: 'http://s3.amazonaws.com/everfi-next/uploads/demo-images/Credit+Scores.png',
    },
    {
      name: 'Retirement Planning',
      description: 'Plan now for your future retirement.',
      image: 'http://s3.amazonaws.com/everfi-next/uploads/demo-images/Credit+Scores.png',
    },
    {
      name: 'Aging Parents',
      description: 'What you need to know to care for aging parents and/or sick children.',
      image: 'http://s3.amazonaws.com/everfi-next/uploads/demo-images/Considering+Home+Ownership.png',
    },
    {
      name: 'Financial Health',
      description: 'The basics...what you need to know about your finances',
      image: 'https://s3.amazonaws.com/everfi-next/uploads/demo-images/Insurance.png',
    },
  ],
};

const DEFAULT_PLAYLIST_LIMIT = 25;

const PlaylistsWidget = ({
  program = DEFAULT_PROGRAM,
  playlistLimit = DEFAULT_PLAYLIST_LIMIT,
  renderAsLegacy = true,
}) => {
  const getPlaylistLimit = () => {
    if (playlistLimit > program.playlists.length) {
      return program.playlists.length;
    } else {
      return playlistLimit;
    }
  };
  injectCustomerColorsCSS(program.primary_color, program.secondary_color);

  return (
    <ChakraComponentWrapper
      comp="PlaylistCardContainer"
      playlistLimit={getPlaylistLimit()}
      program={program}
      renderAsLegacy={renderAsLegacy}
    />
  );
};

PlaylistsWidget.propTypes = {
  program: PropTypes.object,
  playlistLimit: PropTypes.number,
  renderAsLegacy: PropTypes.bool,
};

export default PlaylistsWidget;
